module.exports = __webpack_public_path__ + "static/media/google_cloud_thumbnail.adda1013.png";